import $ from 'jquery'
import ManageSectionFrom from '@/views/consultations/en-cours/consultation-sections/manage-section-form'
import PreviewFile from '@/views/consultations/en-cours/consultation-sections/preview-file'
import store_fiche from "@/store/mods/consultations/fiche-consultations"

export default {
    name: 'consultation-sections',
    components: {
        ManageSectionFrom, PreviewFile
    },
    props: {
        consultation: Object,
        section_name: String,
        slug: String,
        fcs_id: {
            type: Number,
            default: () => (0)
        },
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object,
        patient: Object
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            info_patient: {},
            info_user: {},
            grs_toggler: 0,
            group_id: 0,
            list_contents: [],
            selected_content: [],
            data_to_be_deleted: {},

            liste_champs: [],
            liste_champ_empty: false,
            liste_champ_loading: true,

            prev_info: {
                file_name: '',
                label: ''
            },
            prev_toggler: 0,
            c_slug: ""
        }
    },

    watch: {
        evolution_toggler() {
            this.getData()

            this.userInfoSetter()
            this.getListeChamps()
        }
    },

    computed: {
        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        },
    },


    mounted() {
        
    },

    methods: {
        getListeChamps() {
            this.liste_champ_loading = true
            const data = {
                fcs_id: this.fcs_id
            }
            store_fiche.geListeChampByFicheSection(data).then((response) => {
                this.liste_champs = response

                if (this.liste_champs.length == 0) {
                    this.liste_champ_empty = true
                } else {
                    this.liste_champ_empty = false
                }
                this.liste_champ_loading = false
            })
        },

        userInfoSetter() {
            this.info_patient = {
                nom_patient: this.patient.nom+' '+this.patient.prenoms,
                sexe: (this.patient.sexe_id == 1)?'H':(this.patient.sexe_id == 2)?'F':'',
                telephone: this.patient.telephone_mobile,
                num_dossier: this.patient.code,
                age: this.patient.age,
                date_naissance: this.formatDateToDmY(this.patient.date_naissance)
            }

            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        addNew() {
            this.group_id = 0
            this.selected_content = []
            
            this.grs_toggler = (this.grs_toggler == 0)?1:0
            $('#section-'+this.evolution_id+'-'+this.slug).modal('show')
        },

        getData() {
            this.is_loading = true
            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                data_type: this.slug,
                est_en_cours: true
            }

            store_fiche.getCustomSectionContent(data).then((response) => {
                this.list_contents = response
                if (response.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                
                this.is_loading = false
            })
        },

        previewFile(data) {
            this.prev_toggler = (this.prev_toggler == 0)?1:0

            this.prev_info = {
                file_name: data.value,
                label: data.field_name
            }

            const timestamp = new Date().getTime();
            this.c_slug = this.slug+timestamp
            setTimeout(() => {
                $('.preview-file-'+this.evolution_id+this.c_slug).modal('show')
            }, 500);
            
        },

        removeSection(data) {
            this.data_to_be_deleted = {
                libelle: data.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: data.group_service_id,
                data_type: this.slug
            }

            $('.del-grp-sect'+this.evolution_id+this.slug).modal('show')
        }
    }
}